import { render, staticRenderFns } from "./StaffSales.vue?vue&type=template&id=a9297442&"
import script from "./StaffSales.vue?vue&type=script&lang=js&"
export * from "./StaffSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports